import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Selector opcional de "Sede" — solo se muestra si el cliente elegido tiene
 * sedes cargadas. Si no tiene ninguna, no renderiza nada (sede única implícita,
 * compatibilidad total con clientes sin sedes). */
export function SiteSelect({ clientId, value, onChange, testIdPrefix = "site", required = false, label, onSitesLoaded }) {
  const [sites, setSites] = useState([]);

  useEffect(() => {
    if (!clientId) { setSites([]); return; }
    (async () => {
      try { const { data } = await api.get(`/clients/${clientId}/sites`); setSites(data || []); }
      catch { setSites([]); }
    })();
  }, [clientId]);

  useEffect(() => {
    if (sites.length > 0 && !value) {
      if (sites.length === 1) onChange(sites[0].id);
    }
    onSitesLoaded && onSitesLoaded(sites);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sites]);

  if (sites.length === 0) return null;

  return (
    <div className="field">
      <label>{label || (required ? "Sede *" : "Sede (opcional)")}</label>
      <select required={required} value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={`${testIdPrefix}-site-select`}>
        <option value="">{required ? "Elegí la sede..." : "Sin sede específica"}</option>
        {sites.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
      </select>
    </div>
  );
}
